import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#398FF5",
      d: "m7.431 13.647 6.264-6.263 3.087 3.087-6.264 6.263-3.087-3.087ZM17.538 1.91l-.435.434 4.552 4.552.435-.434a1.288 1.288 0 0 0 0-1.82L19.357 1.91a1.288 1.288 0 0 0-1.82 0ZM13.466 2.115 11.74 3.84l8.616 8.616 1.725-1.725a1.288 1.288 0 0 0 0-1.82l-6.796-6.796a1.288 1.288 0 0 0-1.82 0ZM2.132 15.206l6.797 6.797a1.288 1.288 0 0 0 1.819 0l1.726-1.726-8.616-8.616-1.726 1.726a1.288 1.288 0 0 0 0 1.82ZM1.91 19.261l2.732 2.733a1.288 1.288 0 0 0 1.82 0l.434-.435-4.552-4.552-.435.435a1.288 1.288 0 0 0 0 1.82Z"
    }, null, -1)
  ]))]))
}
export default { render: render }